// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609241904/js/" + chunkId + "." + {"44":"5cc6f023","225":"5ba64c4c","481":"a7154676","486":"7c19ef57","770":"74c3ee86"}[chunkId] + ".0.6486983125407849.chunk.js";
};